export const cityList = [
  { id: 1, name: 'Agra' },
  { id: 2, name: 'Ahmedabad' },
  { id: 3, name: 'Ajmer' },
  { id: 4, name: 'Aligarh' },
  { id: 5, name: 'Allahabad' },
  { id: 6, name: 'Ambattur' },
  { id: 7, name: 'Amravati' },
  { id: 8, name: 'Amritsar' },
  { id: 9, name: 'Asansol' },
  { id: 10, name: 'Aurangabad' },
  { id: 11, name: 'Bangalore' },
  { id: 12, name: 'Bareilly' },
  { id: 13, name: 'Belgaum' },
  { id: 14, name: 'Bhavnagar' },
  { id: 15, name: 'Bhilai Nagar' },
  { id: 16, name: 'Bhiwandi' },
  { id: 17, name: 'Bhopal' },
  { id: 18, name: 'Bhubaneswar' },
  { id: 19, name: 'Bikaner' },
  { id: 20, name: 'Chandigarh' },
  { id: 21, name: 'Chennai' },
  { id: 22, name: 'Coimbatore' },
  { id: 23, name: 'Cuttack' },
  { id: 24, name: 'Dehradun' },
  { id: 25, name: 'Delhi' },
  { id: 26, name: 'Dhanbad' },
  { id: 27, name: 'Durgapur' },
  { id: 28, name: 'Faridabad' },
  { id: 29, name: 'Firozabad' },
  { id: 30, name: 'Gaya' },
  { id: 31, name: 'Ghaziabad' },
  { id: 32, name: 'Gorakhpur' },
  { id: 33, name: 'Gulbarga' },
  { id: 34, name: 'Guntur' },
  { id: 35, name: 'Gurgaon' },
  { id: 36, name: 'Guwahati' },
  { id: 37, name: 'Gwalior' },
  { id: 38, name: 'Haora' },
  { id: 39, name: 'Hubli And Dharwad' },
  { id: 40, name: 'Hyderabad' },
  { id: 41, name: 'Indore' },
  { id: 42, name: 'Jabalpur' },
  { id: 43, name: 'Jaipur' },
  { id: 44, name: 'Jalandhar' },
  { id: 45, name: 'Jalgaon' },
  { id: 46, name: 'Jammu' },
  { id: 47, name: 'Jamnagar' },
  { id: 48, name: 'Jamshedpur' },
  { id: 49, name: 'Jhansi' },
  { id: 50, name: 'Jodhpur' },
  { id: 51, name: 'Kalyan & Dombivali' },
  { id: 52, name: 'Kanpur' },
  { id: 53, name: 'Kochi' },
  { id: 54, name: 'Kolapur' },
  { id: 55, name: 'Kolkata' },
  { id: 56, name: 'Kota' },
  { id: 57, name: 'Loni' },
  { id: 58, name: 'Lucknow' },
  { id: 59, name: 'Ludhiana' },
  { id: 60, name: 'Madurai' },
  { id: 61, name: 'Maheshtala' },
  { id: 62, name: 'Malegaon' },
  { id: 63, name: 'Mangalore' },
  { id: 64, name: 'Meerut' },
  { id: 65, name: 'Mira And Bhayander' },
  { id: 66, name: 'Moradabad' },
  { id: 67, name: 'Mumbai' },
  { id: 68, name: 'Nagpur' },
  { id: 69, name: 'Nanded Waghala' },
  { id: 70, name: 'Nashik' },
  { id: 71, name: 'Navi Mumbai' },
  { id: 72, name: 'Nellore' },
  { id: 73, name: 'Noida' },
  { id: 74, name: 'Patna' },
  { id: 75, name: 'Pimpri & Chinchwad' },
  { id: 76, name: 'Pune' },
  { id: 77, name: 'Raipur' },
  { id: 78, name: 'Rajkot' },
  { id: 79, name: 'Ranchi' },
  { id: 80, name: 'Saharanpur' },
  { id: 81, name: 'Salem' },
  { id: 82, name: 'Sangli Miraj Kupwad' },
  { id: 83, name: 'Siliguri' },
  { id: 84, name: 'Solapur' },
  { id: 85, name: 'Srinagar' },
  { id: 86, name: 'Surat' },
  { id: 87, name: 'Thane' },
  { id: 88, name: 'Thiruvananthapuram' },
  { id: 89, name: 'Tiruchirappalli' },
  { id: 90, name: 'Tirunelveli' },
  { id: 91, name: 'Udaipur' },
  { id: 92, name: 'Ujjain' },
  { id: 93, name: 'Ulhasnagar' },
  { id: 94, name: 'Vadodara' },
  { id: 95, name: 'Varanasi' },
  { id: 96, name: 'Vasai Virar' },
  { id: 97, name: 'Vijayawada' },
  { id: 98, name: 'Visakhapatnam' },
  { id: 99, name: 'Warangal' },
  { id: 100, name: 'Other' },
];